import { Market, PrivacySettingToggles } from '../types/market';
import { gb as adConfig } from '../ads';

const market: Market = {
  countryCode: 'gb',
  active: true,
  permanentRedirect: true,
  sitename: 'PriceSpy',
  superSearchEndpoint: 'https://search.pricespy.co.uk/rfe',
  redirectHosts: ['m.pricespy.co.uk', 'www.pricespy.co.uk'],
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  classicProxy: {
    host: 'int-classic-gb.prisjakt.io',
    port: 8080,
  },
  hrefLang: ['en', 'en-GB'],
  sites: {
    production: 'https://pricespy.co.uk',
    classic: 'https://classic.pricespy.co.uk',
    analytics: 'https://classic.pricespy.co.uk/analytics/store/',
    brands: undefined,
    forum: undefined,
  },
  api: {
    default: 'http://int-api-gb.prisjakt.io:8080/v1',
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
  },
  amp: {
    enabled: true,
    tracking: {
      googleTagManager: 'GTM-5NK99DW',
      facebookPixel: '828683013917028',
    },
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'en_GB',
  timezone: 'Europe/London',
  currencyCode: 'GBP',
  url: {
    campaigns: '/theme',
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      info: '/info.php',
      lists: '/list.php',
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/expert.php',
      store_info: '/store.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.pricespy.co.uk',
    },
  },
  email: {
    noreply: 'noreply@pricespy.co.uk',
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/pricespy/',
    },
    facebook: {
      enableLogin: true,
      link: 'https://www.facebook.com/PriceSpyUK',
      clientID: '405110652852028',
      clientSecret: '922e16645580d015a322b0077c1f1ea1',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
    twitter: {
      // @TODO: Twitter accounts created on RFE platform fails to authorize. Disable until we can find out why.
      enableLogin: false,
      link: 'https://twitter.com/PriceSpyUK',
      consumerKey: '',
      consumerSecret: '',
      callbackURL: '',
    },
  },
  cdn: {
    base: 'https://cdn.pji.nu',
    origin: 'http://int-cdn-origin.prisjakt.io:8080',
    images: 'https://cdn.pji.nu/images/',
  },
  routes: {
    giftGuide: {
      // HACK: Must include all current running giftGuides, hardcoded
      path:
        '/theme/:name(christmas-gift-ideas|great-british-baking-equipment)/:list?',
    },
    themes: {
      path: '/theme',
    },
    campaign: {
      path: '/theme/:name',
    },
  },
  popularCampaignFilterPaths: [
    {
      title: 'Best TV deals under £1000',
      path: '?category=107&price=1-1000&sort=rank%7Cdesc',
    },
    {
      title: 'Best deals under £50',
      path: '?sort=rank%7Cdesc&price=1-50',
    },
    {
      title: 'Best deals £50-100',
      path: '?sort=rank%7Cdesc&price=50-100',
    },
    {
      title: 'Most popular perfumes',
      path: '?sort=product.popularity.total&category=965',
    },
    {
      title: 'Most popular vacuum cleaners',
      path: '?sort=product.popularity.total&category=515',
    },
  ],

  infoPages: [9, 5, 15, 10, 12, 4, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
  },
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey:
      '8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4',
    list: 'BYajAsGm',
    gansubFormId: 'Q2lk',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  ads: { active: true, ...adConfig },
  privacySettings: {
    responsive: {
      cookieVersion: '3',
      cookieUrl: '/info/cookies--i7',
      privacyUrl: '/info/privacy-policy--i6',
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '3',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  structuredData: {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    legalName: 'PriceSpy Ltd',
    areaServed: 'GB',
    url: 'https://pricespy.co.uk',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Sweden House, 5 Upper Montagu Street',
      addressLocality: 'London',
      postalCode: 'W1H 2AG',
      addressCountry: 'United Kingdom',
    },
    logo: 'https://cdn.pji.nu/g/rfe/logos/logo_gb.svg',
    sameAs: [
      'https://www.facebook.com/PriceSpyUK',
      'https://twitter.com/pricespyuk',
    ],
  },
  modules: {
    priceInfo: {
      enabled: false,
    },
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showClassicSwitch: false,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  shopOfTheYear: {
    isVotingOpen: false,
    year: 2018,
  },
};

export default market;
